
function journeyReducer(state = {}, action = {} as any) {

  switch (action.type) {
    case 'UPDATE_PAGE_COUNT':
      return {
        ...state,
        'noOfPagesInJourney': action.payload.noOfPagesInJourney
      };
      // For now added update journey json for sonarFix
    case 'UPDATE_JOURNEY_JSON':
      return {
        ...state
      };
    default:
      return state;
  }
}

export default journeyReducer;
